export default __webpack_public_path__ + "static/media/school.47c3158e.svg";